module.exports = __webpack_public_path__ + "img/IT_cluster.1c86a176.png";